// extracted by mini-css-extract-plugin
export default {"button":"Button_button__95jqg","red":"Button_red__0Nrdr","white":"Button_white__HkSxE","loading":"Button_loading__Fq7J6","none":"Button_none__On8q5"};